<template>
  <b-container>
    <b-row class="tabviewtable itemstableview">
      <b-col>
        <div v-if="windowWidth > 545">
          <SkeletonTableLoader :columns="headers" :loading="loading" />
          <div v-if="!loading">
            <MasterEmpty :createline="false" v-if="List.length === 0 && !loading" eheader="Users" econtent="Users"
              eimg="/src/assets/Img/icons/itemmaster.svg" @createNew="IsAdd" />
            <Tableview v-if="List.length !== 0" :value="List" :paginator="true" class="p-datatable-gridlines" :rows="10"
              :rowHover="true" filterDisplay="menu" :loading="loading1" responsiveLayout="scroll" :columns="headers"
              :globalFilterFields="globalFilterFields" :filters="filters" selectionMode="single" @row-click="RowClick"
              :totalRecords="rowsCount" :state="state" :exceldownload="true">
              <template v-slot:Add v-if="Addstatus">
                <span>
                  <AddButton @click="IsAdd()" btnname="+ Add New" class="float-rights my-3">
                  </AddButton>
                </span>
              </template>
              <template v-slot:exceldownload>
                <ExportOption @ExportExcel="ExportExcel" @ExportPDF="ExportPDF" :ExportList="ExportList"
                  PageName="Items Table" :ExportOption="ExportOption" class="ms-2" :HideAndShow="true" />
              </template>

            </Tableview>
          </div>
        </div>
        <div v-if="windowWidth <= 545">
          <MobileLoader v-if="loading" v-for="item in 5" />
          <div v-if="!loading">
            <MasterEmpty :createline="false" v-if="List.length === 0 && !loading" eheader="Item" econtent="Item"
              eimg="/src/assets/Img/icons/itemmaster.svg" @createNew="IsAdd" />
            <MobileViewCardHeader :totalRecords="rowsCount" :state="state">
              <template v-slot:mobilecard>
                <div class="mobile-card" v-for="item in List" @click="RowClick(item)">
                  <div class="d-flex align-items-center gap-1">
                    <p class="light-name">{{ item.Code }} /</p>
                    <p class="light-name1">{{ item.HSNName }}</p>
                  </div>
                  <p class="name">{{ item.ItemName }}</p>
                  <div class="d-flex align-items-center gap-2">
                    <p class="light-name">Stock in Hand :</p>
                    <p class="small-name">{{ item.BranchId }}</p>
                  </div>
                  <div class="d-flex align-items-center gap-2">
                    <p class="light-name">MRP :</p>
                    <p class="small-name">{{ item.MRP }}</p>
                  </div>
                </div>
              </template>
            </MobileViewCardHeader>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-container>
  <ItemsRightSidebar :itemId="itemId" v-model:visible="visibleRight" position="right" @close="visibleRight = false" />
</template>

<script lang="ts">
// import Header from '../../components/Layout/Header.vue';
import {
  defineComponent,
  ref,
  h,
  onMounted,
  computed,
  watch,
  reactive,
  onUnmounted,
} from "vue";
import Headerlayout from "../../../../components/Masters/HeaderLayout.vue";
import BacktoPage from "../../../../components/FormComponents/BacktoMaster.vue";

import { RouterLink, RouterView, useRouter, useRoute } from "vue-router";
import axios from "axios";

import { FilterMatchMode, FilterOperator } from "primevue/api";
import Tableview from "../../../../components/FormComponents/Table.vue";
import EditConfirmation from "../../../../components/FormComponents/EditConfirmation.vue";
import DeleteConfirmationVue from "../../../../components/FormComponents/DeleteConfirmation.vue";
import DeletedSuccessfully from "../../../../components/FormComponents/DeletedSuccessfully.vue";
import ItemsRightSidebar from "../../../../modules/Inventory/components/Sidebar/RightSidebar/ItemDetailsRightSidebar.vue";
import SupplierCategoryMappingService from "../../../../modules/Inventory/Service//SupplierCategoryMappingService";
import SupplierMasterservice from "../../../../modules/Inventory/Service/SupplierCategoryMappingService";
import servicesupplier from "../../../../modules/Inventory/Service/SupplierMaster";
import itemlistservice from "../../../../modules/Inventory/Service/ItemMasService";
import Loader from "../../../../components/FormComponents/Loader.vue";
import MasterEmpty from "../../../../components/Masters/MasterEmpty.vue";
import SkeletonTableLoader from "../../../../components/FormComponents/SkeletonTableLoader.vue";
import MobileViewCardHeader from "../../../../components/FormComponents/MobileViewCardHeader.vue";
import MobileLoader from "../../../../components/SkeletonLoaderComponents/ContactCardView.vue";
import ExportOption from "../../../../components/FormComponents/Export.vue";
import StoreService from "../../../../modules/Inventory/Service/StoreService";
import { useI18n } from 'vue-i18n';
export default defineComponent({
  components: {
    BacktoPage,
    Headerlayout,

    Tableview,
    EditConfirmation,
    DeleteConfirmationVue,
    DeletedSuccessfully,
    ItemsRightSidebar,
    Loader,
    MasterEmpty,
    SkeletonTableLoader,
    MobileViewCardHeader,
    MobileLoader,
    ExportOption,
  },
  props: {
    propsParams: {
      type: Object,
    },
    Addstatus: {
      type: Boolean,
      Default: true,
    },
  },
  setup(props, { emit }) {
    debugger;
    const { t } = useI18n();
    const state = reactive({
      pagedItems: [], // contains a subset of rows for the current page
      currentPage: 1, // current page number
      pageSize: 10, // number of rows per page
      totalRows: 0, // total number of rows in the database
    });
    // const windowWidth = ref(window.innerWidth);
    const windowWidth = ref(window.innerWidth);
    const handleResize = () => {
      windowWidth.value = window.innerWidth;
    };

    onMounted(() => {
      window.addEventListener("resize", handleResize);
    });

    onUnmounted(() => {
      window.removeEventListener("resize", handleResize);
    });
    const router = useRouter();
    const routes = useRoute();
    const itemId = ref(0);
    const filter = "";
    const showmodalref = ref(false);
    let loading1 = ref(false);
    let title = "Item Master";
    const showDialog = ref(false);
    let List: any = ref([]);
    const selectedItem = ref();
    const data = ref([]);
    const rowFocus = ref(false);
    const editItems = ref();
    const Editmodel = ref(false);
    // const { t } = useI18n();
    const Deletemodel = ref(false);
    const deletepop = ref(false);
    const visibleRight = ref(false);
    const ColumnVisible = ref(true);
    let SessionUserData = localStorage.getItem("UsersData");
    let usersData;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }
    const ParamValues = ref({
      requestId: "",
      Id: 0,
      Type: 0,
    });
    let StoreId = routes.query.Id ?? 0;
    let status = routes.query.Type ?? 0;
    const rowsCount = ref(0);
    ParamValues.value.Id = Number(StoreId);
    ParamValues.value.Type = Number(status);
    if (status == "SupplierId") {
      ColumnVisible.value = true;
    } else {
      ColumnVisible.value = false;
    }
    let dataValue = {
      StoreId: "",
      status: "",
    };
    let loading = ref(false);
    watch(
      () => routes.query.Id,
      (newVal: any) => {
        debugger;
        ParamValues.value.Id = Number(newVal);
        if (status == "SupplierId") {
          ColumnVisible.value = true;
        } else {
          ColumnVisible.value = false;
        }
        IsShow();
      }
    );

    // watch(props, (newValue) => {
    //     debugger;
    //     Object.assign(dataValue, newValue.propsParams)
    //     ParamValues.value.Id = Number(props.propsParams)
    //     IsShow()

    // })
    watch(
      [() => state.currentPage, () => state.pageSize],
      async ([pageNum, pageSize]) => {
        debugger;
        await IsShow();
      }
    );
    function onRowClick(event: Event, rowData: any) {
      emit("row-click", rowData);
    }

    async function IsShow() {
      debugger;
      try {
        loading.value = true;
        debugger;
        var result = await StoreService.ListUserByStoreId(
          StoreId,
          usersData.OrganizationId
        );
        let count = 0;
        List.value = result["result"].map((item) => {
          count = count + 1;
          item.RowNumber = count;
          return item;
        });
        loading.value = false;
      } catch (error) {
        loading.value = false;

        console.log(error);
      }
    }

    const headers = [
      {
        header: t('storetabdetails.users.sno'),
        field: "RowNumber",
        class: "filterdisplaynone",
      },
      {
        header: t('storetabdetails.users.Code'),
        field: "Code",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t('storetabdetails.users.Name'),
        field: "UserName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass text_overflow2",
        class: "mediumwidth",
      },
      {
        header: t('storetabdetails.users.Role'),
        field: "RoleName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "text_overflow2",
        class: "mediumwidth",
      },
      {
        header: t('storetabdetails.users.Designation'),
        field: "Designation",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "text_overflow2",
        class: "mediumwidth",
      },
      {
        header: t('storetabdetails.users.BranchName'),
        field: "BranchName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "text_overflow2",
        class: "mediumwidth",
      },
      {
        header: t('storetabdetails.users.DepartmentName'),
        field: "DepartmentName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "text_overflow2",
        class: "mediumwidth",
      },

      {
        header: t('storetabdetails.users.SubDepartmentName'),
        field: "SubDepartmentName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "text_overflow2",
        class: "mediumwidth",
      },
    ];

    const filteredColumns = computed(() => {
      return headers.filter((col) => col.field !== "id");
    });

    const globalFilterFields = ref(headers.map((col) => col.field));

    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      Code: { value: null, matchMode: FilterMatchMode.IN, options: List },
      ItemProductId: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: List,
      },
      HSNName: { value: null, matchMode: FilterMatchMode.IN, options: List },
      ItemName: { value: null, matchMode: FilterMatchMode.IN, options: List },
      ManufactureName: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: List,
      },
      UnitName: { value: null, matchMode: FilterMatchMode.IN, options: List },
      ItemCategoryName: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: List,
      },
      ItemGroupName: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: List,
      },
      ItemSubGroupName: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: List,
      },
      ItemGenericName: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: List,
      },
    };

    let ExportOption = ref("");
    let ExportList = ref([]);

    function ExportExcel() {
      debugger;
      ExportOption.value = "Excel";
      IsShowExport();
    }

    function ExportPDF() {
      debugger;
      ExportOption.value = "PDF";
      IsShowExport();
    }

    async function IsShowExport() {
      debugger;
      try {
        loading.value = false;

        var result = await StoreService.ListUserByStoreId(
          StoreId,
          usersData.OrganizationId
        );
        let count = 0;
        List.value = result["result"].map((item) => {
          count = count + 1;
          item.RowNumber = count;
          return item;
        });
        console.log(List.value);
        ExportList.value = result["result"].map((item) => {
          const filteredItem = {};

          headers.forEach(({ header, field }) => {
            filteredItem[header] = item[field];
          });

          return filteredItem;
        });
        console.log("ContactTable Data", List.value);
        loading.value = false;
      } catch (error) {
        loading.value = false;
      }
    }

    onMounted(() => {
      IsShow();

      debugger;
      document.addEventListener("keydown", onKeyUp);
    });
    const dataEdit = ref();
    function onKeyUp(event: any) {
      debugger;

      console.log(dataEdit.value);
      if (
        (event.key == "e" ||
          (Editmodel.value == false && event.key == "Enter")) &&
        rowFocus.value == true
      ) {
        Editmodel.value = true;
      } else if (event.altKey && event.key == "n") {
        IsAdd();
      } else if (
        (event.key == "y" || event.key == "Enter") &&
        Deletemodel.value == true &&
        Editmodel.value == false &&
        rowFocus.value == true
      ) {
      } else if (
        event.key == "n" &&
        rowFocus.value == true &&
        Editmodel.value == true
      ) {
        Editmodel.value = false;
      } else if (event.key == "d" && rowFocus.value == true) {
        Deletemodel.value = true;
        Editmodel.value = false;
      } else if (
        event.key == "n" &&
        rowFocus.value == true &&
        Deletemodel.value == true
      ) {
        Deletemodel.value = false;
      } else if (event.key == "Escape" && deletepop.value == true) {
        deletepop.value = false;
      } else if (event.key == "Enter" && rowFocus.value == false) {
        Editmodel.value = false;
      }
    }

    function RowClick(event: any) {
      // visibleRight.value = true;
      // itemId.value = event.data ? event.data.Id : event.Id;
    }

    //Add New PopUp
    const IsAdd = () => {
      router.push({
        path: "/ItemMasterCreation",
      });
    };
    function IsConfirmEdit(data) {
      debugger;
      dataEdit.value = data;
      Editmodel.value = true;
    }
    function IsConfirmDel(data) {
      debugger;
      dataEdit.value = data;
      Editmodel.value = false;
      Deletemodel.value = true;
    }
    // Popup-Close
    function closetrigger() {
      deletepop.value = false;
    }

    return {
      ParamValues,
      title,
      headers,
      filter,
      showmodalref,
      showpopModal: showmodalref,
      loading1,
      List,
      filters,
      globalFilterFields,
      filteredColumns,
      IsShow,
      RowClick,
      dataEdit,
      Editmodel,
      IsAdd,
      onKeyUp,
      IsConfirmEdit,
      IsConfirmDel,
      Deletemodel,
      closetrigger,
      deletepop,
      visibleRight,
      onRowClick,
      rowsCount,
      state,
      loading,
      itemId,
      windowWidth,
      ExportExcel,
      ExportOption,
      ExportPDF,
      ExportList,
    };
  },
});
</script>
<style lang="scss" scoped>
.mobiledarkname {
  font-size: 16px;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  margin-top: -7px;
}

.mobilelightname {
  font-size: 14px;
  color: #999999;
}

.mobilenrmlname {
  font-size: 14px;
  font-weight: 400;
}
</style>
<style lang="scss">
.itemstableview .p-datatable .p-datatable-thead>tr>th:last-child {
  border-left: 1px solid #e1e1e1 !important;
}
</style>
